import http from "./../../services/http.service";
import i18n from "@/shared/i18n";

const QrCodeService = {
  generateQrCode(data) {
    return http.put(`/api/v1/qr-code/generate/`, {data});
  },
  batchGenerateQrCode(data) {
    return http.put(`/api/v1/qr-code/batch-generate/`, {data});
  },
  getReaderInitializationError(error) {
    const map = {
      'NotAllowedError': i18n.t("You need to grant camera access permission"),
      'NotFoundError': i18n.t("Camera not detected on this device"),
      'NotSupportedError': i18n.t("Secure context required (HTTPS, localhost)"),
      'NotReadableError': i18n.t("Camera already in use. Please try again later"),
      'OverconstrainedError': i18n.t("Installed cameras are not suitable"),
      'StreamApiNotSupportedError': i18n.t("Stream API is not supported in this browser"),
    };
    return map[error.name];
  },
  getQrCodeInfo(data) {
    return http.get(`/api/v1/qr-code/model-data/`, {
      params: {
        "qr_code_data": data
      }
    });
  }
}

export default QrCodeService;
